/**
 * Video modal: plays selected (native) videos or YouTube in #video-modal.
 * Triggers:
 *   Native: <a class="is-video" href="#" data-video-src="/path/to/video.mp4" data-video-type="video/mp4">
 *   YouTube: <a class="is-video" href="#" data-video-id="YOUTUBE_ID"> (loadVideo from youtube.js)
 */
(function () {
    var modalSelector = '#video-modal.modal';
    var playerContainerId = 'modal-player';
    var nativeVideoId = 'modal-native-video';

    function loadNativeVideo(src, type) {
        var $modal = $(modalSelector);
        var $container = $('#' + playerContainerId);
        if (!$modal.length || !$container.length) return;

        $container.empty();
        var $video = $('<video>', {
            id: nativeVideoId,
            controls: true,
            playsinline: true,
            preload: 'auto',
            class: 'w-100'
        }).css('maxHeight', '80vh');
        $video.append($('<source>', { src: src, type: type || 'video/mp4' }));
        $container.append($video);
        $modal.modal('show');

        var el = document.getElementById(nativeVideoId);
        if (el) {
            el.load();
            el.play().catch(function () {});
        }
        $modal.one('shown.bs.modal', function () {
            var videoEl = document.getElementById(nativeVideoId);
            if (videoEl) videoEl.play().catch(function () {});
        });
    }

    function cleanupNativeVideo() {
        var nativeVideo = document.getElementById(nativeVideoId);
        if (nativeVideo) {
            nativeVideo.pause();
            nativeVideo.remove();
        }
        var $container = $('#' + playerContainerId);
        if ($container.length) $container.empty();
    }

    $(document).ready(function () {
        // Single handler: native video (data-video-src) or YouTube (data-video-id)
        $(document.body).on('click', 'a.is-video', function (e) {
            console.log('click',$(this).attr('data-video-src'),$(this).attr('data-video-id'));
            e.preventDefault();
            var videoSrc = $(this).attr('data-video-src');
            var videoType = $(this).attr('data-video-type') || 'video/mp4';
            if (videoSrc) {
                loadNativeVideo(videoSrc, videoType);
                return;
            }
            var videoId = $(this).attr('data-video-id');
            if (typeof window.loadVideo === 'function') {
                window.loadVideo(videoId);
            }
        });

        $(modalSelector).on('hidden.bs.modal', function () {
            if (document.getElementById(nativeVideoId)) {
                cleanupNativeVideo();
            }
        });
    });
})();
